var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarApplicationsIconHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16683 2.29169C4.05177 2.29169 3.9585 2.38496 3.9585 2.50002V17.5C3.9585 17.6151 4.05177 17.7084 4.16683 17.7084H15.8335C15.9486 17.7084 16.0418 17.6151 16.0418 17.5V2.50002C16.0418 2.38496 15.9486 2.29169 15.8335 2.29169H4.16683ZM2.7085 2.50002C2.7085 1.69461 3.36141 1.04169 4.16683 1.04169H15.8335C16.6389 1.04169 17.2918 1.69461 17.2918 2.50002V17.5C17.2918 18.3054 16.6389 18.9584 15.8335 18.9584H4.16683C3.36141 18.9584 2.7085 18.3054 2.7085 17.5V2.50002Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.7085 6.25002C7.7085 4.98438 8.73453 3.95835 10.0002 3.95835C11.2658 3.95835 12.2918 4.98438 12.2918 6.25002C12.2918 7.51566 11.2658 8.54169 10.0002 8.54169C8.73453 8.54169 7.7085 7.51566 7.7085 6.25002ZM10.0002 5.20835C9.42488 5.20835 8.9585 5.67474 8.9585 6.25002C8.9585 6.8253 9.42488 7.29169 10.0002 7.29169C10.5754 7.29169 11.0418 6.8253 11.0418 6.25002C11.0418 5.67474 10.5754 5.20835 10.0002 5.20835Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87516 10.4167C6.87516 8.6908 8.27428 7.29169 10.0002 7.29169C11.726 7.29169 13.1252 8.6908 13.1252 10.4167C13.1252 10.7619 12.8453 11.0417 12.5002 11.0417C12.155 11.0417 11.8752 10.7619 11.8752 10.4167C11.8752 9.38116 11.0357 8.54169 10.0002 8.54169C8.96463 8.54169 8.12516 9.38116 8.12516 10.4167C8.12516 10.7619 7.84534 11.0417 7.50016 11.0417C7.15498 11.0417 6.87516 10.7619 6.87516 10.4167Z",
    fill: "#2D2943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87516 12.9167C6.87516 12.5715 7.15498 12.2917 7.50016 12.2917H12.5002C12.8453 12.2917 13.1252 12.5715 13.1252 12.9167C13.1252 13.2619 12.8453 13.5417 12.5002 13.5417H7.50016C7.15498 13.5417 6.87516 13.2619 6.87516 12.9167Z",
    fill: "#787395"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87516 15.4167C6.87516 15.0715 7.15498 14.7917 7.50016 14.7917H10.4168C10.762 14.7917 11.0418 15.0715 11.0418 15.4167C11.0418 15.7619 10.762 16.0417 10.4168 16.0417H7.50016C7.15498 16.0417 6.87516 15.7619 6.87516 15.4167Z",
    fill: "#787395"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarApplicationsIconHover);
export default __webpack_public_path__ + "static/media/sidebar-applications-icon-hover.55f8b7bc.svg";
export { ForwardRef as ReactComponent };